import { Box, Modal, Paper, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { SetStateAction, useEffect, useState } from 'react'
import { SnackbarProvider } from 'notistack'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import SelectOrgs from './SelectOrgs'
import API from '@enums/api'

type Props = {
    open: boolean
    setOpen: React.Dispatch<SetStateAction<boolean>>
}

export default function CheckOrgOrdersModal(props: Props) {
    const { open, setOpen } = props
    const [loading, setLoading] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [selectedOrg, setSelectedOrg] = useState<string | undefined>(
        undefined
    )
    const [hasOrders, setHasOrders] = useState<boolean | undefined>(undefined)

    useEffect(() => {
        setHasOrders(undefined)
    }, [selectedOrg])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setLoading(true)
        setLoaded(false)

        const res = await API.searches.countOrgOrders(selectedOrg!)

        if (!res.ok) {
            console.error(res.error)
            setHasOrders(false)
        } else {
            setHasOrders(res.value.count > 0)
        }

        setLoaded(true)
        setLoading(false)
    }

    return (
        <>
            <Modal
                open={open}
                onClose={() => {
                    setLoading(false)
                    setOpen(false)
                }}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="100vh"
                >
                    <Paper
                        sx={{
                            width: 600,
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            position: 'relative',
                        }}
                    >
                        <button
                            type="submit"
                            onClick={() => setOpen(false)}
                            style={{
                                position: 'absolute',
                                top: 6,
                                right: 6,
                                border: 'none',
                            }}
                        >
                            <CloseIcon
                                sx={{
                                    width: 20,
                                    height: 20,
                                    padding: 0,
                                    margin: 0,
                                }}
                            />
                        </button>
                        <Typography id="modal-title" variant="h5" mb={'16px'}>
                            Check if an organisation has orders
                        </Typography>
                        <form
                            onSubmit={(e) => handleSubmit(e)}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '16px',
                                marginTop: '16px',
                            }}
                        >
                            <SelectOrgs
                                sx={{ width: '80%' }}
                                selectedOrg={selectedOrg}
                                setSelectedOrg={setSelectedOrg}
                            ></SelectOrgs>
                            <LoadingButton
                                startIcon={<SearchIcon />}
                                variant="contained"
                                type="submit"
                                loading={loading}
                            >
                                Search
                            </LoadingButton>
                        </form>
                        {loaded && (
                            <Box
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px',
                                    marginTop: '16px',
                                }}
                            >
                                {hasOrders === true && (
                                    //  colour the background green
                                    <Box color="green">
                                        <Typography
                                            variant="body1"
                                            component={'h3'}
                                        >
                                            This organisation has orders!
                                        </Typography>
                                    </Box>
                                )}
                                {hasOrders === false && (
                                    <Box color="red">
                                        <Typography
                                            variant="body1"
                                            component={'h3'}
                                        >
                                            This organisation has no orders!
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Paper>
                </Box>
            </Modal>
            <SnackbarProvider
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            />
        </>
    )
}
